export { default } from './DataTreatment';
